import '../styles/AuthButton.css';
import { signInWithGoogle, signOut } from '../utils/supabase';
import { soundManager } from '../utils/sounds';

/**
 * Shows Google sign-in when logged out, avatar + name when logged in.
 * Receives `user` prop from App.jsx auth state.
 */
function AuthButton({ user }) {
  const handleSignIn = () => {
    soundManager.playClick();
    signInWithGoogle();
  };

  const handleSignOut = () => {
    soundManager.playClick();
    signOut();
  };

  if (user) {
    return (
      <div className="auth-user">
        {user.user_metadata?.avatar_url && (
          <img
            src={user.user_metadata.avatar_url}
            alt="avatar"
            className="auth-avatar"
            referrerPolicy="no-referrer"
          />
        )}
        <span className="auth-name">
          {user.user_metadata?.full_name?.split(' ')[0] ?? 'Player'}
        </span>
        <button className="auth-signout-btn" onClick={handleSignOut} title="Sign out">
          ×
        </button>
      </div>
    );
  }

  return null;
}

export default AuthButton;
